export function SessionStyles() {
  return (
    <style>{`
      @keyframes drawCheck {
        0% { stroke-dashoffset: 100; opacity: 0; }
        20% { opacity: 1; }
        100% { stroke-dashoffset: 0; opacity: 1; }
      }
      .animate-draw-check {
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        animation: drawCheck 1.2s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        animation-delay: 0.2s;
      }
      .animate-scale-in {
        animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
      }
      @keyframes scaleIn {
        from { transform: scale(0.5); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
      @keyframes blink {
        0%, 100% {
          opacity: 1;
          box-shadow: 0 0 30px rgba(239, 68, 68, 0.6);
        }
        50% {
          opacity: 0.7;
          box-shadow: 0 0 50px rgba(239, 68, 68, 0.9);
        }
      }
      .animate-blink {
        animation: blink 1s ease-in-out infinite;
      }
    `}</style>
  )
}
